/**
 * @voltxampere/ui — LM324 quad general-purpose op-amp variant (Sprint 39-1)
 *
 * Same per-amp specs as LM358 in DIP-14 with four channels. Uses the
 * same single-pole macro stamp via `schemaType: "opamp"`; the visual
 * representation is the single-channel triangle since the canvas
 * does not draw multi-channel ICs as a unit (each channel lands as
 * its own placement, sharing the underlying part number through the
 * Inspector).
 *
 * Reference: TI SLOS066AB.
 *
 * Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const opampLm324 = {
    id: "lm324",
    nameTr: "LM324 (Quad, DIP-14)",
    nameEn: "LM324 (Quad, DIP-14)",
    shortcut: "O",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "LM324",
    schemaType: "opamp",
    defaultParams: {
        openLoopGain: 1e5,
        saturationVoltage: 12,
        gainBandwidthProduct: 1e6,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=opamp-lm324.js.map